<template>
  <a-modal
    width="1320px"
    :title="title"
    :mask-closable="false"
    :visible="exercisesTimesVisible"
    :userId="userId"
    @cancel="onCancelShowExercisesTimes"
    :footer="null"
    :destroyOnClose="true"
    class="show-login-list"
  >
    <a-table
      :columns="showQuestionColumns"
      :data-source="data"
      :loading="loading"
      :row-key="(record) => record.id"
      :pagination="{
        pageSize,
        total,
        current,
        showTotal: (total) => `共${total}条`,
      }"
      @change="changePage"
    >
      <template slot="is_submit" slot-scope="text, record">
        <a-badge status="success" text="已完成" v-if="record.is_submit == 1" />
        <a-badge status="processing" text="练习中" v-else />
      </template>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="() => showExercisesDetail(record)"
          >查看</a
        >
      </template>
    </a-table>

    <!-- 显示学员练习答题详情-->
    <a-modal
      width="750px"
      :title="exercisesName"
      :mask-closable="false"
      :visible="exercisesTimesDetailVisible"
      @cancel="onCancelShowExercisesTimesDetail"
      :footer="null"
      :destroyOnClose="true"
      class="show-login-list show-exercises-times"
    >
      <div v-if="exercisesTimesDetailLoading" class="spin"><a-spin /></div>
      <div
        class="qbox"
        v-for="(item, index) in exercisesTimesDetailData"
        :key="index"
      >
        <!-- 题干 -->
        <div class="question-header">
          <span class="type">{{ getType(item.type) }}</span>
          <span class="stems">{{ ++index }}. {{ item.title }}</span>
        </div>
        <div class="question-body">
          <!-- 选项 -->
          <div
            class="answer-box"
            v-for="(anitem, anindex) in item.questionAnswerList"
            :class="switchAnswer(anitem.answerTitle, item.rightkey)"
            :key="anindex"
          >
            <div style="display: flex">
              <div style="width: 20px">{{ anitem.answerTitle }}.</div>
              <div>{{ anitem.content }}</div>
            </div>
            <div class="icon">
              <a-icon
                :type="
                  switchAnswer(anitem.answerTitle, item.rightkey) == 'red'
                    ? 'close-circle'
                    : 'check-circle'
                "
              />
            </div>
          </div>

          <!-- 答案 -->
          <div class="answers">
            <div class="answer-box">
              <div class="right">
                正确答案：<span class="green">{{ item.rightkey }}</span>
              </div>
              <div>已选答案：{{ item.myAnswer }}</div>
            </div>
            <!-- 知识点解析 -->
            <div class="knowledges" v-if="item.knowledges != undefined">
              <span class="jiexi">解析：</span>
              <span
                class="em"
                v-for="(knitem, knindex) in item.knowledges"
                :key="knindex"
                >{{ knitem }}</span
              >
            </div>
          </div>
        </div>
        <a-divider
          type="horizontal"
          :dashed="true"
          v-if="index != exercisesTimesDetailData.length"
        />
      </div>
    </a-modal>
  </a-modal>
</template>

<script>
import { showQuestionColumns } from "../data/index";
export default {
  props: ["userId", "userName", "userGrade", "exercisesTimesVisible"],
  data() {
    return {
      showQuestionColumns,
      loginList: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      data: [],
      title: "",
      exercisesName: "",
      exercisesId: "",
      exercisesTimesDetailVisible: false,
      exercisesTimesDetailLoading: false,
      exercisesTimesDetailData: [],
    };
  },
  watch: {
    exercisesTimesVisible(val) {
      if (this.exercisesTimesVisible) {
        this.title = this.userName + "(班级: " + this.userGrade + ")  练习记录";
        this.showList();
      }
    },
  },
  mounted() {},
  methods: {
    onCancelShowExercisesTimesDetail() {
      this.exercisesName = "";
      this.exercisesTimesDetailData = [];
      this.exercisesTimesDetailVisible = false;
    },
    async showExercisesDetail(row) {
      this.exercisesName = row.title;
      this.exercisesTimesDetailVisible = true;
      this.exercisesTimesDetailLoading = true;
      let result = await this.$http.post("/promoter/showPaperDetail", {
        id: row.id,
      });
      if (result.data.status === 1) {
        this.exercisesTimesDetailLoading = false;
        this.exercisesTimesDetailData = result.data.data.answers
          ? result.data.data.answers
          : result.data.data.progress;
      } else {
        this.exercisesTimesDetailLoading = false;
      }
    },
    onCancelShowExercisesTimes() {
      this.data = [];
      this.total = 0;
      this.current = 1;
      this.title = "";
      this.$parent.hiddenModelType("exercises");
    },
    hiddenExercisesDetailModel() {
      this.exercisesId = "";
      this.exercisesName = "";
      this.exercisesTimesDetailVisible = false;
    },
    async showList() {
      this.loading = true;
      let params = {
        page: this.current,
        pageSize: this.pageSize,
        userId: this.userId,
        type: "exercises",
      };
      let result = await this.$http.post("/promoter/showPaperList", params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            title: item.title,
            question_total: item.question_total,
            will_answer: item.will_answer,
            answer_total: item.answer_total,
            answer_rate: item.answer_rate,
            right_num: item.right_num,
            right_rate: item.right_rate,
            errors_num: item.errors_num,
            errors_rate: item.errors_rate,
            create_time_txt: item.create_time_txt,
            is_submit: item.is_submit,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      } else {
        this.loading = false;
        this.$message.error(result.data.msg);
      }
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.showList({
        page: this.current,
        pageSize: this.pageSize,
        userId: this.userId,
      });
    },
    switchAnswer(answerTitle, rightkey) {
      let rightkeyArr = rightkey.split(",");
      return rightkeyArr.includes(answerTitle) ? "green" : "red";
    },
    getType(type) {
      let name = "";
      if (type == 1) {
        name = "单选题";
      } else if (type == 2) {
        name = "多选题";
      } else if (type == 3) {
        name = "判断题";
      } else {
        name = "简答题";
      }

      return name;
    },
  },
};
</script>

<style>
.show-login-list .ant-modal-content .ant-modal-header {
  padding: 16px 24px;
  color: rgba(0, 0, 0, 0.65);
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  height: auto;
}
.show-login-list .ant-modal-content .ant-modal-header .ant-modal-title {
  margin: 0 !important;
}

.show-exercises-times {
  top: 2px !important;
  padding-bottom: 0;
}

.show-exercises-times .ant-modal-body {
  max-height: calc(100vh - 60px);
  overflow-y: auto;
}
</style>
<style lang="scss" scoped>
.spin {
  text-align: center;
}
.qbox {
  padding-bottom: 0px;

  .question-header {
    width: 100%;
    margin-bottom: 15px;

    .type {
      background: #1890ff;
      padding: 1px 5px;
      display: inline-block;
      border-radius: 2px;
      color: #ffffff;
      margin-right: 5px;
    }

    .stems {
      font-size: 16px;
      font-weight: 500;
    }
  }

  .question-body {
    .answer-box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      font-size: 14px;

      .icon {
        padding-left: 3px;
      }

      .right {
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .answers {
      border: 1px solid #eff6ff;
      background: #eff6ff;
      border-radius: 5px;
      margin: 10px auto;
      display: block;
      padding: 15px;
    }

    .red {
      color: red;
    }
    .green {
      color: green;
    }

    .knowledges {
      margin-top: 20px;

      span {
        display: block;
        margin-bottom: 5px;
      }
      .jiexi {
        font-weight: 500;
      }

      .em {
        text-indent: 1em;
      }
    }
  }
}
</style>